export default {"src":"/_next/static/media/account-addresses-icon.b26b1540.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};